import { render } from "./Authorize.vue?vue&type=template&id=713d3906&scoped=true"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"

import "./Authorize.vue?vue&type=style&index=0&id=713d3906&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713d3906"]])

export default __exports__